'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex, Text } from '@chakra-ui/react'

import { Input } from 'components/form/Input'
import { Button } from 'components/ui/Buttons/Button'
import LeidModal from 'components/ui/Modal/LeidModal'

import { NewsletterLogic } from '../NewsletterLogic'

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const NewsletterModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation(['common', 'newsletter'])

  return (
    <NewsletterLogic
      children={({ getFieldProps, touched, errors, handleSubmit }) => (
        <LeidModal header={t('newsletter:header')} isOpen={isOpen} onClose={onClose}>
          <Flex
            width="54px"
            height="54px"
            backgroundColor="green.a200"
            borderRadius="12px"
            position="absolute"
            right={{ base: 0, md: '-74px' }}
            top={{ base: '-74px', md: 0 }}
            alignItems="center"
            justifyContent="center"
            cursor="pointer"
            onClick={onClose}
          >
            <img src="/icons/close-light.svg" alt="Close" />
          </Flex>

          <Text fontWeight={300} fontSize="sm" marginBottom="36px">
            {t('newsletter:body')}
          </Text>

          <Flex flexDirection="column">
            <Box marginBottom="36px">
              <Input
                {...getFieldProps('email')}
                placeholder={t('newsletter:emailPlaceholder')}
                name="email"
                touched={touched.email}
                error={errors.email}
                label={t('newsletter:emailPlaceholder')}
              />
            </Box>

            <Button onClick={handleSubmit}>{t('newsletter:cta')}</Button>
          </Flex>
        </LeidModal>
      )}
    />
  )
}
